var map = {
	"./SpaceLab_DonatePage1_Background.png": 3490,
	"./add_icon.svg": 6030,
	"./donate_payment_group.png": 2530,
	"./donate_title_section_image.png": 1967,
	"./down_arrow.svg": 4451,
	"./feedback_angelinies.png": 6572,
	"./feedback_laura.png": 8624,
	"./group_image.png": 65,
	"./group_of_two_men.png": 9293,
	"./icon _rocket.png": 8391,
	"./one_woman_talking_and_one_laughing.png": 1238,
	"./purple-sky-unsplash.jpg": 6623,
	"./small_star.svg": 6165,
	"./spacelab.svg": 417,
	"./three_women_chatting.png": 7732,
	"./up_arrow_image.png": 7073
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3127;